import { useMediaQuery } from 'react-responsive';
import theme from '../../../../assets/stylesheets/_settings.global.scss';

export default function CommonProps() {
  const mediaQueries = {
    isXXLarge: useMediaQuery({ query: `(min-width: ${theme.breakpointXxlargeMin})` }),
    isXLarge: useMediaQuery({ query: `(min-width: ${theme.breakpointXlargeMin})` }),
    isLarge: useMediaQuery({ query: `(min-width: ${theme.breakpointLargeMin})` }),
    isMobile: useMediaQuery({ query: `(max-width: ${theme.breakpointSmallMax})` }),
    isMobileOrTablet: useMediaQuery({ query: `(max-width: ${theme.breakpointMediumMax})` }),
  };

  mediaQueries.isTablet = mediaQueries.isMobileOrTablet && !mediaQueries.isMobile;

  return {
    ...theme,
    ...mediaQueries,
  };
}
